import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

interface TabPanelProps {
  children?: React.ReactNode;
  index: any;
  value: any;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: any) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles(() => ({
  root: {
    maxWidth: '65%',
    width: '100%',
    backgroundColor: '#F5F5FB',
  },
}));

interface AlternativasProps {
  conteudo: string;
  correta: boolean;
}
interface QuestoesProps {
  titulo: string;
  alternativas: AlternativasProps[];
}
interface ApiProps {
  title: {
    rendered: string;
  };
  acf: {
    experimental: {
      video: string;
      materiais: {
        apostila: {
          arquivo: {
            title: string;
            description: string;
            url: string;
          };
          titulo: string;
          descricao: string;
        };
        conteudo: string;
      };
      professor: {
        bio: string;
        especialidade: string;
        imagem: {
          url: string;
        };
        nome_do_professor: string;
        titulo: string;
      };
      sobre: {
        descricao: string;
      };
      teste_seus_conhecimentos: {
        gabarito: {
          arquivo: {
            url: string;
            title: string;
            description: string;
          };
        };
        questoes: QuestoesProps[];
      };
    };
  };
}

interface Props {
  data: ApiProps | null;
  hangleTab: any;
}

export default function TabsEurofarma({ data, hangleTab }: Props) {
  const classes = useStyles();
  const [value, setValue] = useState(0);

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
    hangleTab(newValue);
  };

  return (
    <div className={classes.root}>
      <AppBar
        position="static"
        style={{
          background: '#F5F5FB',
          color: '#6b6b6b',
          boxShadow: 'none',
        }}
      >
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="simple tabs example"
          TabIndicatorProps={{
            style: {
              backgroundColor: '#00CFB4',
            },
          }}
        >
          <Tab label="Material" {...a11yProps(0)} style={{ fontWeight: 700 }} />
          <Tab label="Sobre" {...a11yProps(1)} style={{ fontWeight: 700 }} />
        </Tabs>
      </AppBar>
      <TabPanel value={value} index={0}>
        {data?.acf.experimental.materiais.conteudo && (
          <div
            className="tabs-content"
            dangerouslySetInnerHTML={{
              __html: data.acf.experimental.materiais.conteudo,
            }}
          />
        )}
      </TabPanel>
      <TabPanel value={value} index={1}>
        {data?.acf.experimental.sobre.descricao && (
          <div
            className="tabs-content"
            dangerouslySetInnerHTML={{
              __html: data.acf.experimental.sobre.descricao,
            }}
          />
        )}
      </TabPanel>
    </div>
  );
}
